<template>
  <ListView
    modelName="StockRelocationItem"
    perm="stock.menu_stock_relocation_item"
    svg = "icon_side_stock_move_list" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_stock_relocation_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="StockRelocationItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    borderColor="#61AA72"
    backColor="#EAFFEF"            
    :comparer="(a,b)=>a.id == b.id"
    :popup="popup"                
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="stockRelocationItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.stockRelocationItemNo }}</GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.stockRelocation.bookDate | date }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.stockRelocation.warehouseOut.name}}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.stockRelocation.warehouseIn.name }}</GridItem>



    <!-- <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->

    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.commodity.uom }}</GridItem>    
    <GridItem :slot="listSlots[8]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.stockRelocationNo }}</GridItem>    
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>          
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.stockRelocation.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.stockRelocation.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.stockRelocation.refNo }}</GridItem>

    <GridItem :slot="listSlots[14]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1Out)}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2Out)}}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3Out)}}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4Out)}}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5Out)}}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6Out)}}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1Out)}}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2Out)}}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3Out)}}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1Out) | date}}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2Out) | date}}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3Out)| date}}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1Out ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2Out ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3Out ) | category_43}}</GridItem> 

    <GridItem :slot="listSlots[29]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1In)}}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2In)}}</GridItem>
    <GridItem :slot="listSlots[31]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3In)}}</GridItem>
    <GridItem :slot="listSlots[32]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4In)}}</GridItem>
    <GridItem :slot="listSlots[33]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5In)}}</GridItem>
    <GridItem :slot="listSlots[34]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6In)}}</GridItem>
    <GridItem :slot="listSlots[35]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1In)}}</GridItem>
    <GridItem :slot="listSlots[36]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2In)}}</GridItem>
    <GridItem :slot="listSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3In)}}</GridItem>
    <GridItem :slot="listSlots[38]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1In) | date}}</GridItem>
    <GridItem :slot="listSlots[39]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2In) | date}}</GridItem>
    <GridItem :slot="listSlots[40]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3In)| date}}</GridItem>
    <GridItem :slot="listSlots[41]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1In ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[42]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2In ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[43]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3In ) | category_43}}</GridItem>

    <!-- <GridItem :slot="listSlots[44]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <GridItem :slot="listSlots[44]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[45]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[46]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[47]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false" >
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <FilterBox title="在庫移動番号" :value.sync="params.stockRelocationNo" @click="handler" />
        <FilterBox title="在庫移動明細番号" :value.sync="params.stockRelocationItemNo" @click="handler" />            
        <FilterBox title="管理番号" :value.sync="params.refNo" @click="handler" />
        <AtcCounterpart title="出庫倉庫" :value.sync="params.warehouseOut" :needsWarehouse="true" @changed="handler" />
        <AtcCounterpart title="入庫倉庫" :value.sync="params.warehouseIn" :needsWarehouse="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>           
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />

        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />        
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />              
        <Calendar title="発生日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="発生日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />              
        <ComboBox title="状態" :value.sync="params.state" list="stockRelocationItemStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->        
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','出庫予備項目','入庫予備項目','更新履歴']">        
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="明細番号" :value="item.stockRelocationItemNo" :editor="editor" :enabled="false" tooltip="在庫移動番号に紐づく明細番号が初回保存時に自動で付与されます。" />
              <!-- <TextBox title="行番号" :value="item.seqNo" :editor="editor" :enabled="false" /> -->
              <Calendar title="発生日" :value="item.stockRelocation.bookDate" :editor="editor" :enabled="false" tooltip="【在庫一覧】の在庫移動子画面で指定された発生日です。" />
              <AtcCounterpart title="出庫倉庫" :value="item.stockRelocation.warehouseOut" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="在庫の移動元倉庫です。【在庫一覧】で在庫移動処理が行われた在庫の倉庫です。" />
              <AtcCounterpart title="入庫倉庫" :value="item.stockRelocation.warehouseIn" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="在庫の移動先倉庫です。【在庫移動一覧】で設定されている入庫倉庫です。" />
              <AtcCommodity title="商品" :value="item.commodity" :editor="editor" :enabled="false" tooltip="在庫移動を行う商品です。変更する場合は改めて在庫移動を行ってください。" />
              <AtcSKU title="SKU" :value="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" tooltip="在庫移動を行う商品のSKUです。変更する場合は改めて在庫移動を行ってください。" />              
              <TextBox title="単位" :value="item.commodity.uom" :editor="editor" :enabled="false" tooltip="在庫移動を行う商品の計上単位です。" />
              <NumericBox title="移動数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="item.state == savingFlag" :decimals="item.commodity?item.commodity.quantityScale:0" min="0" max="99999999.999" :nullValue="0" tooltip="在庫移動を行う数量です。【出庫倉庫】から数量分在庫が減少し、【入庫倉庫】の在庫へ加算されます。" />                    
             </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="在庫移動番号" :value="item.stockRelocationNo" :enabled="false" :linkFormat="getStockRelocationLinkFormat(item)" tooltip="在庫移動の初回保存時に自動で付与された番号です。"/>     
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="false"/>                   
              <AtcSegment title="部門" :value="item.stockRelocation.segment" :editor="editor" :enabled="false" tooltip="在庫移動を行う部門です。部門を跨ぐ移動はできません。部門を跨ぐ場合は、在庫振替を行ってください。" />
              <AutoComplete title="担当者" :value="item.stockRelocation.pic" :editor="editor" list="user" :enabled="false" tooltip="在庫移動の担当者が表示されています。在庫移動明細一覧からの変更は出来ません。" />
              <TextBox title="管理番号" :value="item.stockRelocation.refNo" :editor="editor" :enabled="false" tooltip="在庫移動の管理番号が表示されています。在庫移動明細一覧からの変更は出来ません。" />
              <!-- <TextBox title="所有者" :value="item.holder" :editor="editor" :enabled="false" />-->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="在庫移動明細情報を最後に編集した日時が表示されています。" />                      
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_stockRelocationItem" :required="$api.perms.hasWorkflow('stockRelocationItem')" :enabled="$api.perms.hasWorkflow('stockRelocationItem') && $api.perms.isEntryStatus(item)" :nullValue="0" /> -->
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'stockRelocationItemStatus')" :enabled="false" tooltip="在庫移動情報の現在の状態です。" />                  
            </template>
          </EditPanel>
        </template>
        <!-- 出庫予備項目タブ -->
        <template slot="tab1" slot-scope="{ item, editor  }">
          <PnlReserveItems :item="item.transferOut" :editor="editor" :enabled="false" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :commodity="item.commodity" /> 
        </template>      
        <!-- 入庫予備項目タブ -->
        <template slot="tab2" slot-scope="{ item, editor  }">
          <PnlReserveItems :item="item.transferIn" :editor="editor" :enabled="item.state == savingFlag" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :commodity="item.commodity" /> 
        </template>              
        <!-- 更新履歴タブ -->
        <template slot="tab3" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockRelocationItemView extends Vue {
  public items: Common.StockRelocationItem[] = new Array(0);
  public params: Common.StockRelocationItemQuery = new Common.StockRelocationItemQuery();
  public importQuery = new Common.ImportQuery('在庫移動明細','StockRelocationItem');
  public exportQuery = new Common.ExportQuery('在庫移動明細',this.params);
  public tenantSettings: Common.TenantSettings = null;
    public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'State', text:'状態' },    
    { value: 'stockRelocationItemNo', text: '明細番号' },
    { value: 'stockRelocationNo', text: '在庫移動番号' },     
    { value: 'bookDate', text: '発生日' },    
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'warehouseOut', text: '出庫倉庫' },    
    { value: 'segment', text: '部門' },
    { value: 'commodity', text: '商品' },    
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },        
  ];
  @Prop() public stockRelocationNo:string;
  @Prop() public stockRelocationItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor; 

  public inputType:Common.InputTypes = Common.InputTypes.Delivery;
  public savingFlag: Common.StockRelocationItemStatus = Common.StockRelocationItemStatus.StockRelocationWaiting;
  public visibleTypes = Common.visibleTypes;  

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =new Common.GridConfiguration([],14, 'grid');


  public created() {
    this.tenantSettings = this.$api.tenantSettings;

     // 明細の予備項目表示の可変対応
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('出庫倉庫', 150),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('移動数量', 150),

      new Common.GridItemConfiguration('在庫移動番号', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('管理番号', 150),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'出庫|'));
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'入庫|'));
    this.listGridConfig.setGridItems(
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );

    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.stockRelocationNo){
      this.params.stockRelocationNo = this.stockRelocationNo;
      this.params.state = null;
    }
    if(this.stockRelocationItemNo) {
      this.params.stockRelocationItemNo = this.stockRelocationItemNo;
      this.params.state = null;
    }
    if(!this.stockRelocationItemNo && !this.stockRelocationNo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.StockRelocationItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_stockRelocationItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 在庫振替一覧へ遷移する
  public getStockRelocationLinkFormat(item : Common.StockTransferItem){
    return '/journal/StockRelocation?stockRelocationNo={0}';
  }


  
}
</script>